<template>
  <div class="personinfo">
    <UserHeaderNav :current="current" :titleMsg='titleMsg'></UserHeaderNav>
    <div class="news-content w1200">
      <div class="left-main">
        <h2 class="clum">
          <i class="icon">账号信息</i>
        </h2>
        <div class="left-item">
          <div class="items" :class="selected === '0'?'acitve':''"><span @click="showCheck(0)">个人信息</span></div>
          <div class="items" :class="selected === '1'?'acitve':''"><span @click="showCheck(1)">查询证书</span></div>
          <!-- <span>{{memberInfo.memberType}}</span> -->
          <div class="items" :class="selected === '2'?'acitve':''" v-if="assoUserInfo.memberType === 1 && assoUserInfo.status === 1"><span @click="showCheck(2)">证书管理</span></div>
          <div class="items" :class="selected === '3'?'acitve':''" v-if="assoUserInfo.memberType === 1 && assoUserInfo.status === 1"><span @click="showCheck(3)" >成员管理</span></div>
        </div>
      </div>
      <div class="personal-certificate" v-if="selected === '1'">
        <div class="certificate-nav">
          <h2 class="person-text-title"><span>{{seacheTitle}}</span></h2>

          <div class="check-nav" v-if="isSearch">
             <!-- <el-input
              placeholder="请输入需要查询证书人姓名"
              v-model="name"
              clearable>
            </el-input> -->
            <el-input
              placeholder="请输入需要查询证书编号"
              v-model="certificateNumStr"
              width='400px'
              clearable>
            </el-input>
            <div class="submit-btn">
              <el-button type="primary" icon="el-icon-search" @click="getPersonCertificatr()">搜索</el-button>
            </div>
          </div>
          <ReferCertificate v-if="isResult"></ReferCertificate>
          <div class="submit-btn" style="width:100%;text-align: center;margin-top:20px;" v-if="isResult">
            <span style="padding: 10px 50px;background: #cc0000;border-radius:5px;color: #fff;cursor: pointer;" @click="backGetCertificate()">返回</span>
            <!-- <el-button type="primary" icon="el-icon-search" @click="getPersonCertificatr()">搜索</el-button> -->
          </div>

        </div>

      </div>
      <div class="person-info" v-if="selected === '0'">
        <div class="right-main">
          <h2 class="right-title">个人信息</h2>
          <div class="right-item">
            <span class="user-name icon-name">账号</span>
            <span class="name-text">{{assoUserInfo.phoneNo}}</span>
            <span class="updata"></span>
          </div>
          <div class="right-item">
            <span class="user-name icon-pass">密码</span>
            <input type="password" class="showPass" disabled="disabled" v-model="password" />
            <span class="name-text"></span>
            <span class="updata" @click="showUpdataPass()">修改</span>
          </div>
          <div class="right-item">
            <span class="user-name icon-user">姓名</span>
            <span class="name-text">{{assoUserInfo.memberName}}</span>
            <!-- <span class="updata">修改</span> -->
          </div>
          <div class="right-item" v-if="assoUserInfo.status === 2">
            <el-collapse accordion>
              <el-collapse-item>
                <template slot="title">
                  <div style="width:140px;display: flex;justify-content: flex-start;align-items: center;">
                    <img src="/static/images/icon-right.png" alt="" style="margin-right:15px;float:left;" >
                    <img src="/static/images/icon-state.png" alt=""  style="float:left;width:25px;height:27px;" >
                    <span style="float:left;padding-left:5px;color:#666;font-size:14px;">审核状态</span>
                  </div>
                  <div style="margin-left:130px;font-size:14px;color:#666;">{{getStatusFun()}}</div>
                  <span class="updata" style="position: absolute;right: 10px;top:17px;color:#666">驳回原因</span>
                  <span class="name-text"></span>
                </template>
                <div style="padding-left:40px;">状态：{{getStatusFun()}}</div>
                <div style="padding-left:40px;" v-if="assoUserInfo.rejectReason !==null" >驳回原因：{{assoUserInfo.rejectReason}}</div>
                 <div style="padding-left:40px;color:#cc0000;cursor: pointer;" @click="conmlement()" v-if="assoUserInfo.rejectReason !==null" >
                   <el-button type="primary" icon="el-icon-edit" size="small">完善驳回信息</el-button>
                 </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="right-item" v-if="assoUserInfo.status !== 2">
              <span class="user-name icon-state">审核状态</span>
              <span class="name-text">{{getStatusFun()}}</span>
              <!-- <span class="reason" style="margin-left:10px;color:#cc0000" v-if="assoUserInfo.status === 2">{{assoUserInfo.rejectReason}}</span> -->
              <!-- <span class="updata">修改</span> -->
            </div>
          <div class="right-item">
            <span class="user-name begin-time">到期时间</span>
            <span class="name-text">{{formatDate(assoUserInfo.endTime)}}</span>
            <!-- <span class="updata">修改</span> -->
          </div>
          <div class="right-item">
            <span class="user-name end-time">会员类型</span>
            <span class="name-text">{{assoUserInfo.memberType === 1?'团体会员':'个人会员'}}</span>
            <!-- <span class="updata">修改</span> -->
          </div>
          <!-- <div class="submit">
            <span>确定</span>
          </div> -->
          <el-dialog title="修改密码" :visible.sync="isShowUpdataPass" width="30%">
            <el-form>
              <el-form-item label="电话号码" :label-width="formLabelWidth">
                <el-input v-model="phone" placeholder="请输入内容"></el-input>
              </el-form-item>
              <el-form-item label="旧密码" :label-width="formLabelWidth">
                <el-input placeholder="请输入旧密码" v-model="oldPass" show-password></el-input>
              </el-form-item>
              <el-form-item label="新密码" :label-width="formLabelWidth">
                <el-input placeholder="请输入新密码" v-model="newPass" show-password></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="isShowUpdataPass = false">取 消</el-button>
              <el-button type="primary" @click="updataPassFun()">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="manage" v-if="selected === '2'">
        <ManageCertificate></ManageCertificate>
      </div>
      <div class="member" v-if="selected === '3'">
        <ManageMember></ManageMember>
      </div>

    </div>

    <CopyRight></CopyRight>

  </div>
</template>

<script>
import { modifiedPwd, findUserCertDetail } from '@/api/association'
import UserHeaderNav from '@/components/common/UserCenter/UserHeaderNav'
import ReferCertificate from '@/components/common/UserCenter/ReferCertificate'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import ManageCertificate from '@/components/common/UserCenter/manageCertificate'
import ManageMember from '@/components/common/UserCenter/manageMember'
import {formatDate} from '@/components/common/config/formatTime.js'
import md5 from 'js-md5'
export default {
  name: '',
  components: {
    UserHeaderNav,
    CopyRight,
    md5,
    ManageCertificate,
    ManageMember,
    ReferCertificate
  },
  data () {
    return {
      current: null,
      loading: false,
      isResult: false,
      isSearch: true,
      seacheTitle: '个人证书查询',
      selected: '0',
      isShowUpdataPass: false,
      formLabelWidth: '100px',
      certificateNumStr: '',
      assoDesc: {},
      pageNum: 1,
      pageSize: 6,
      total: null,
      password: '',
      phone: '',
      oldPass: '',
      newPass: '',
      type: this.$route.params.type,
      currentPage: 1,
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      titleMsg: '个人信息',
      // memberInfo: JSON.parse(localStorage.getItem('memberInfo')),
      heightStyle: {
        height: '0px;'
      }
    }
  },
  methods: {
    formatDate,
    backGetCertificate () {
      this.isResult = false
      this.isSearch = true
      this.seacheTitle = '个人证书查询'
      localStorage.removeItem('referResultData')
    },
    conmlement () {
      this.$router.push({
        name: 'ComplementInfo'
      })
    },
    resetHeight () {
      let headH = this.$refs.headH.clientHeight
      let screnH = document.body.clientHeight
      console.log(screnH, headH)
      this.heightStyle.height = screnH - headH + 'px'
    },
    getStatusFun () {
      if (this.assoUserInfo.status === 0) {
        return '待审核'
      } else if (this.assoUserInfo.status === 1) {
        return '审核通过 '
      } else if (this.assoUserInfo.status === 2) {
        return '驳回'
      }
    },
    showCheck (num) {
      if (num === 0) {
        this.selected = '0'
      } else if (num === 1) {
        this.selected = '1'
      } else if (num === 2) {
        this.selected = '2'
      } else if (num === 3) {
        this.selected = '3'
      }
    },
    showUpdataPass () {
      this.isShowUpdataPass = true
    },
    updataPassFun () {
      let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (this.phone === '') {
        this.$message.error('请输入手机号！')
        return false
      } else if (!reg.test(this.phone)) {
        this.$message.error('请输入正确的手机号格式！')
        return false
      } else if (this.oldPass === '') {
        this.$message.error('请输入旧密码！')
        return false
      } else if (this.newPass === '') {
        this.$message.error('请输入新密码！')
        return false
      } else if (this.oldPass === this.newPass) {
        this.$message.error('两次密码不能相同！')
        return false
      }
      modifiedPwd({ assoId: localStorage.getItem('assoId'), newPwd: md5(this.newPass), oldPwd: md5(this.oldPass), phoneNo: this.phone }).then(res => {
        if (res.data.status === 0) {
          // that.list = res.data.data.list
          console.log(res.data)
          this.$message.success('密码修改成功')
          this.isShowUpdataPass = false
        }
      }).catch(() => {
        this.$message.error('密码修改失败！请重试')
        this.isShowUpdataPass = false
      })
    },
    // 查询证书
    getPersonCertificatr () {
      if (this.certificateNumStr === '') {
        this.$message.error('请输入需要查询的证书编号')
        return false
      }
      findUserCertDetail({ certNo: this.certificateNumStr, assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          if (res.data.data.length === 0) {
            this.$message.error('没有查询到对应的证书，请核对证书号')
          } else {
            this.isResult = true
            this.isSearch = false
            this.seacheTitle = '证书查询结果'
            localStorage.setItem('referResultData', JSON.stringify(res.data))
            // this.$router.push({
            //   name: 'ReferCertificate'
            // })
          }
        }
      })
    },
    keyDown (e) {
      // 如果是回车则执行登录方法
      if (e.keyCode === 13) {
        this.getPersonCertificatr()
      }
    }

  },
  mounted () { // 这里必须是mouted钩子
    // 绑定事件
    window.addEventListener('keydown', this.keyDown)

    // this.$nextTick(function () {

    // })
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDown, false)
  },
  created () {
    // this.getQueryAssoDesc()
    let str = this.assoUserInfo.pwd
    let str1 = str.substring(0, 8)
    this.password = str1.replace(str1, '********')
    let flag = this.$route.query.flag
    console.log(this.selected)
    if (flag && flag !== null) {
      this.selected = flag
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .personinfo  {
    width: 100%;
    background: url(/static/images/layout-bg.png)0px 0px no-repeat;
    background-size: 100% 100%;
  }

  .news-content {
    width: 1100px;
    padding: 10px 50px;
    margin-top: 10px;
    overflow: hidden;

  }
  .clum {
    overflow: hidden;
    padding: 35px 0px;
  }

  .clum .icon {
    width: 100px;
    display: inline-block;
    font-size: 20px;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(/static/images/nwe-shuxian.png);
    padding-left: 14px;
    font-style: normal;
    margin-left: 40px;
    color: #666;
  }

  .left-main{
    width: 165px;
    background: #fff;
    float: left;
    height: 616px;
    border-radius: 10px;
  }
  .left-item{
    width: 100px;
    margin-left: 40px;
  }
  .left-item .items{
    display: block;
    padding: 10px 0px;
    border-top: 1px solid #eee;

  }
  .left-item .items span{
    display: block;
    padding: 5px 0px;
    color:#666;
    border-radius: 3px;
    text-align: center;
    font-size: 14px;
  }
  .left-item .acitve span{
    background: #cc0000;
    color:#fff;
  }
  .personal-certificate{
    width: 815px;
    margin-left: 20px;
    background: #fff;
    float: right;
    height: 616px;
    padding: 0px 50px;
    border-radius: 10px;
  }
  .certificate-nav{
    float: left;
    width: 100%;
  }
  .person-text-title{
    padding: 30px 0px;
    text-align: center
  }
  .person-text-title span{
    background: url(/static/images/ge-ren.png)0px center no-repeat;
    background-size: 20px 20px;
    padding: 10px 0px 10px 25px;
    font-size: 16px;
  }
  .check-nav{
    padding-top:10px;
    width: 400px;
    margin: 0px auto;
  }
  .check-nav .submit-btn{
    width: 100%;
    text-align: center;
  }
  .check-nav .el-input{
    margin-bottom: 20px;
    text-align: center
  }
  .check-nav .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .personal-certificate .seach{
    width: 100%;
    margin-bottom: 5px;
  }
  .personal-certificate .seach .el-input{
    width: 300px;
  }
  .personal-certificate .el-button{
    background: #cc0000;
    color: #fff;
  }
  .right-main{
    width: 815px;
    margin-left: 20px;
    background: #fff;
    float: right;
    height: 616px;
    padding: 0px 50px;
    border-radius: 10px;

  }
  .right-title{
    font-size: 16px;
    text-align: center;
    color:#666;
    margin-top: 50px;
  }
  .right-item{
    border-bottom: 1px solid #eee;
    padding: 15px 0px;
    overflow: hidden;
    color:#666;
    font-size: 14px;
    line-height: 30px;
    background: url(/static/images/icon-right.png) 0px center no-repeat;
    position: relative;
  }
  .right-item .user-name{
    float: left;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 25px 27px;
    background-size: 25px 27px;
    padding-left: 30px;
    margin-left: 40px;
    width: 100px;
  }
  .showPass{
    font-size: 14px;
    border: none;
    background: none;
    outline:none;
    margin-left: 100px;
  }
  input:focus {
    border: none
  }
  .right-item .icon-name{
    background-image: url(/static/images/login-user.png);
  }
  .right-item .icon-pass{
    background-image: url(/static/images/login-pass.png);
  }
  .right-item .icon-user{
    background-image: url(/static/images/icon-tuanti.png);
  }
  .right-item .icon-state{
    background-image: url(/static/images/icon-state.png);
  }
  .right-item .begin-time{
    background-image: url(/static/images/begin-time.png);
  }
  .right-item .end-time{
    background-image: url(/static/images/end-time.png);
  }
  .right-item .name-text{
    float: left;
    margin-left: 100px;
  }
  .right-item .updata{
    float:right;
    padding:0px 10px;
    cursor: pointer;
  }
  .submit{
    padding-top: 50px;
    text-align: center;
  }
  .submit span{
    padding: 10px 50px;
    background: #cc0000;
    border-radius:5px;
    color: #fff;
    cursor: pointer;
  }
  .manage{
    width: 815px;
    margin-left: 20px;
    background: #fff;
    float: right;
    height: 616px;
    padding: 0px 50px;
    border-radius: 10px;
    position: relative;
  }
  .member{
    width: 815px;
    margin-left: 20px;
    background: #fff;
    float: right;
    height: 616px;
    padding: 0px 50px;
    border-radius: 10px;
    position: relative;
  }
  .person-info /deep/ .el-collapse{
    border:none;
  }
  .person-info /deep/ .el-collapse-item__header{
    border-bottom: none;
  }
  .person-info /deep/ .el-collapse-item__wrap{
    border-bottom: none;
  }
  .fixd {
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 99999;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/PersonInfo .vue